import { Scope } from "../models/General";

export const scopes: Scope[] = [
  {
    name: "sccot-sc-adapter-hana-o9-nonprod",
    value: "api://sccot-sc-adapter-hana-o9-nonprod/.default",
    layer: "process",
  },
  {
    name: "sccot-sc-logistics-brightsize-nonprod",
    value: "api://sccot-sc-logistics-brightsize-nonprod/.default",
    layer: "process",
  },
  {
    name: "sccot-sc-mvf-nonprod",
    value: "api://sccot-sc-mvf-nonprod/.default",
    layer: "process",
  },
  {
    name: "sccot-sc-mainsaver-common-nonprod",
    value: "api://sccot-sc-mainsaver-common-nonprod/.default",
    layer: "process",
  },
  {
    name: "sccot-sc-mainsaver-main-nonprod",
    value: "api://sccot-sc-mainsaver-main-nonprod/.default",
    layer: "process",
  },
  {
    name: "flcit-chemit-logistics-delivery-non-prod",
    value: "ed970a9c-45d3-46de-bfbf-48bfaeccff5f/.default",
    layer: "process",
  },
  {
    name: "flcit-chemit-logistics-shipment-non-prod",
    value: "b4235840-33a5-498f-8790-090750d459d7/.default",
    layer: "process",
  },
  {
    name: "flcit-chemit-logistics-freightorder-nonprod",
    value: "253e191a-7430-408b-962c-7fb2deba3aa8/.default",
    layer: "process",
  },
  {
    name: "flcit-chemit-wim-materialmovement-non-prod",
    value: "3ed54932-9e64-4317-ac88-c94f11bbdac8/.default",
    layer: "process",
  },
  {
    name: "flcit-chemit-wim-pwo-nonprod",
    value: "a75cca1d-3f29-4458-99b8-625b971a0a6c/.default",
    layer: "process",
  },
  {
    name: "flcit-chemit-entitlement-api-dev",
    value: "f3131e47-7ff3-478f-a7c7-dc0d8eecd54e/.default",
    layer: "process",
  },
  {
    name: "flcit-chemit-entitlement-api-acc",
    value: "c85db5f8-8227-43a5-97f0-639287a03201/.default",
    layer: "process",
  },
  {
    name: "EAS-API-LAYER-ACC",
    value: "api://eas-api-layer-acc/.default",
    layer: "process",
  },
  {
    name: "flcit-chemit-wim-qm-nonprod",
    value: "api://flcit-chemit-wim-qm-nonprod/.default",
    layer: "process",
  },
  {
    name: "sccot-sc-process-production-nonprod",
    value: "api://sccot-sc-process-production-nonprod/.default",
    layer: "process",
  },
  {
    name: "sccot-sc-process-goods-movement-nonprod",
    value: "api://sccot-sc-process-goods-movement-nonprod/.default",
    layer: "process",
  },
  {
    name: "sccot-sc-process-inspection-lot-result-nonprod",
    value: "api://sccot-sc-process-inspection-lot-result-nonprod/.default",
    layer: "process",
  },
  {
    name: "sccot-sc-tprm-ariba-api-nonprod",
    value: "0679ab7e-26f7-420f-8f1f-d821b90a9f08/.default",
    layer: "process",
  },
  {
    name: "sccot-sc-tprm-mdg-outbound-api-nonprod",
    value: "50acc843-44c1-49c2-8c0e-458657a381a5/.default",
    layer: "process",
  },
  {
    name: "sccot-sc-mm-sos-api-nonprod",
    value: "api://sccot-sc-mm-sos-api-nonprod/.default",
    layer: "process",
  },
  {
    name: "Snowflake Client App for External Oauth (all accounts)",
    value: "api://b4a7c3b2-4b47-4e08-adae-9247f30ea857/.default",
    layer: "process",
  },

  {
    name: "ExxonMobil APIs",
    value: "api://exxonmobilAPIs",
    layer: "experience",
  },

  
  // Example of maining new scope for outbound layer
  // {
  //   name: "vendor-name",
  //   value: "vendor-app-registration-client-id",
  //   layer: "outbound"
  // }
];
